<template>
    <div class="col-sm-3 mb-5 mb-xl-10" >
      <div class="card card-flush h-lg-100">
        <div class="card-header pt-5">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label fw-bolder text-dark">{{$t('settings.setting_projects')}}</span>
            <span class="text-gray-400 mt-1 fw-bold fs-6"></span>
          </h3>
        </div>
        <div class="card-body pt-5">
          <router-link v-if="$can(abilities.STEP_PROJECT_VIEW)" :to="'projects/settings-projects/steps'">
            <div class="card shadow-sm p-5 mb-2">
              <div class="d-flex flex-stack" >
                <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('settings.steps')}}</a>
                <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                  <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
                </button>
              </div>
            </div>
          </router-link>
          <router-link :to="'projects/settings-projects/status'" v-if="$can(abilities.VIEW_COLUMN)">
            <div class="card shadow-sm p-5 mb-2">
              <div class="d-flex flex-stack" >
                <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('settings.status')}}</a>
                <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                  <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
                </button>
              </div>
            </div>
          </router-link>
          <router-link :to="'projects/settings-projects/priorities'" v-if="$can(abilities.VIEW_PRIORITY)">
            <div class="card shadow-sm p-5 mb-2">
              <div class="d-flex flex-stack" >
                <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('settings.priorities')}}</a>
                <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                  <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
                </button>
              </div>
            </div>
          </router-link>
          <router-link :to="'projects/settings-projects/category/groups'" v-if="$can(abilities.VIEW_CATEGORIES)">
            <div class="card shadow-sm p-5 mb-2">
              <div class="d-flex flex-stack" >
                <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('settings.categoryGroup')}}</a>
                <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                  <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
                </button>
              </div>
            </div>
          </router-link>
          <router-link :to="'projects/settings-projects/categories'" v-if="$can(abilities.VIEW_CATEGORIES)">
            <div class="card shadow-sm p-5 mb-2">
              <div class="d-flex flex-stack" >
                <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('settings.projectTypes')}}</a>
                <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                  <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
                </button>
              </div>
            </div>
          </router-link>
          <router-link :to="'projects/settings-projects/contact/status'" v-if="$can(abilities.VIEW_CATEGORIES)">
            <div class="card shadow-sm p-5 mb-2">
              <div class="d-flex flex-stack" >
                <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('settings.projectContactStatus')}}</a>
                <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                  <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
                </button>
              </div>
            </div>
          </router-link>
          <router-link :to="'projects/settings-projects/property/specifications'" v-if="$can(abilities.VIEW_CATEGORIES)">
            <div class="card shadow-sm p-5 mb-2">
              <div class="d-flex flex-stack" >
                <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('settings.projectPropertySpecification')}}</a>
                <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                  <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
                </button>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import abilities from "@/composables/abilities";


  </script>

  <style scoped>
  
  </style>